import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class AuthModulesGuard  {

  constructor( private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {

    let perm = false;
    if(sessionStorage.currentUser){
      for(const mod of JSON.parse(sessionStorage.currentUser).modules){
        for(const idmod of next.data.modules) {
          if(Number(mod) === idmod) {
            perm = true;
            break;
          }
        }

      }
    }

    if (perm) {
      return true;
    } else {
      //console.log("redirect to 404 ") //redirigo solo cuando es visita
      //this.router.navigate(['/404'], { queryParams: { url: state.url } });
      //return false;
      return true;
    }

  }
}
